<div class="main-container">
  @if (!isLoading && !brand && isValidRequest) {
<img srcset="
/assets/images/knight-frank-white.png 1x,
/assets/images/knight-frank-white@2x.png 2x,
/assets/images/knight-frank-white@3x.png 3x
" alt="Knight Frank" class="logo logo-kf">
  }
  @if (!isLoading && brand && isValidRequest) {
    <img [src]="brand!.logoUrl" [alt]="brand!.name" class="logo logo-kf">
  }

  <div class="form-box-parent">
    <div class="form-box">
      @if (isLoading) {
        <fa-icon [icon]="faSpinnerThird" animation="spin" class="ms-1"></fa-icon> Loading...
      }

      @if (!isLoading) {
        @if (!isValidRequest) {
          <h2>
            Error
          </h2>
          <p>
            Sorry, that record is either invalid or has been closed for editing. Please try again, or contact us if you
            continue to encounter issues.
          </p>
        }
        @if (showDebugInfo && debugInfo) {
          <div class="alert alert-secondary mt-3 small">
            <strong>Debug Info</strong>
            <dl class="mb-0 mt-2">
              <dt>Event</dt>
              <dd>{{ debugInfo.eventType }}</dd>
              <dt>Reason</dt>
              <dd>{{ debugInfo.reason }}</dd>
              @if (debugInfo.organisationId) {
                <dt>Organisation</dt>
                <dd>{{ debugInfo.organisationName ? debugInfo.organisationName + ' (ID: ' + debugInfo.organisationId + ')' : debugInfo.organisationId }}</dd>
              }
              @if (debugInfo.expectedSubdomain) {
                <dt>Expected Subdomain</dt>
                <dd>{{ debugInfo.expectedSubdomain }}</dd>
              }
              @if (debugInfo.attemptedSubdomain) {
                <dt>Attempted Subdomain</dt>
                <dd>{{ debugInfo.attemptedSubdomain }}</dd>
              }
              @if (debugInfo.configuredDomain) {
                <dt>Configured Domain</dt>
                <dd>{{ debugInfo.configuredDomain }}</dd>
              }
              @if (debugInfo.resolvedHost) {
                <dt>Resolved Host</dt>
                <dd>{{ debugInfo.resolvedHost }}</dd>
              }
              @if (debugInfo.resolvedSubdomain) {
                <dt>Resolved Subdomain</dt>
                <dd>{{ debugInfo.resolvedSubdomain }}</dd>
              }
            </dl>
          </div>
        }
        @if (isValidRequest && !wasSubmitSuccessful) {
          <h1 class="mb-4">
            <strong>
              Retail Sales Form
            </strong>
          </h1>
          @if (hasAlreadyBeenSubmitted && !hasSubmitted) {
            <div class="alert alert-warning">
              <strong>
                This record has already been submitted.
              </strong>
              <br>
                Any further changes will supersede those submitted previously.
              </div>
            }
            @if (hasSubmitted && !hasAlreadyBeenSubmitted) {
              <div class="alert alert-warning">
                <strong>
                  Submission was not successful
                </strong>
                <br>
                  Sorry, we encountered an issue submitting your responses. Please try again.
                </div>
              }
              <form [formGroup]="form" novalidate (ngSubmit)="onFormSubmit()">
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <input type="text" class="form-control-plaintext" id="buildingNameAndBuildingID"
                        placeholder="Building Name & Building Id" formControlName="buildingNameAndBuildingID" readonly>
                      <label for="buildingNameAndBuildingID">Building Name & Building Id</label>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <input type="text" class="form-control-plaintext" id="tenantTradingNameAndLeaseID"
                        placeholder="Tenant Trading Name & Lease ID" formControlName="tenantTradingNameAndLeaseID" readonly>
                      <label for="tenantTradingNameAndLeaseID">Tenant Trading Name & Lease ID</label>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <input type="text" class="form-control-plaintext" id="suiteIDAndSuiteNumber"
                        placeholder="Suite ID & Suite Number" formControlName="suiteIDAndSuiteNumber" readonly>
                      <label for="suiteIDAndSuiteNumber">Suite ID & Suite Number</label>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <input type="text" class="form-control-plaintext" id="salesContactEmail"
                        placeholder="Sales contact email" formControlName="salesContactEmail" readonly>
                      <label for="salesContactEmail">Sales contact email</label>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <input type="text" class="form-control-plaintext" id="salesPeriod" placeholder="Sales period"
                        [value]="f.salesPeriod.value | formatYearMonth" readonly>
                      <label for="salesPeriod">Sales period</label>
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="reportType" id="reportTypeReported"
                        formControlName="reportType" value="RPT" [required]="true"
                        [class.is-invalid]="f.reportType.touched && f.reportType.invalid">
                      <label class="form-check-label" for="reportTypeReported">
                        Reported
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="reportType" id="reportTypeCertified"
                        formControlName="reportType" value="CER" [required]="true"
                        [class.is-invalid]="f.reportType.touched && f.reportType.invalid">
                      <label class="form-check-label" for="reportTypeCertified">
                        Certified
                      </label>
                    </div>
                    @if (f.reportType.errors?.required) {
                      <div class="invalid-feedback"
                        [class.d-block]="f.reportType.touched && f.reportType.invalid && f.reportType.errors?.required"
                        >
                        Required
                      </div>
                    }
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <input type="text" class="form-control" id="salesFigure" placeholder="Sales figure"
                        formControlName="salesFigure" [required]="true"
                        [class.is-invalid]="f.salesFigure.touched && f.salesFigure.invalid" prefix="$" mask="separator.2"
                        thousandSeparator=",">
                      <label for="salesFigure">Sales figure (excluding GST)</label>
                      @if (f.salesFigure.errors?.required) {
                        <div class="invalid-feedback">
                          Required
                        </div>
                      }
                      @if (f.salesFigure.errors?.pattern) {
                        <div class="invalid-feedback">
                          Invalid figure
                        </div>
                      }
                    </div>
                  </div>
                </div>
                @if (isUploading) {
                  <div class="row mb-4">
                    <div class="col-12">
                      <div class="alert mb-0 small alert-success">
                        <fa-icon [icon]="faSpinnerThird" animation="spin" class="ms-1"></fa-icon> Uploading attachment...
                      </div>
                    </div>
                  </div>
                }
                @if (!isUploading) {
                  @if (attachmentAlreadySupplied || f.attachment.value) {
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="alert mb-0" [class.alert-success]="!allowUpload && !f.attachment.invalid" [class.alert-danger]="allowUpload || f.attachment.errors?.invalidFile">
                          <div class="row">
                            <div class="col-12 col-md-7">
                              @if (!allowUpload && !f.attachment.invalid) {
                                <fa-icon [icon]="faFileCheck" class="me-1"></fa-icon>
                                An attachment has been supplied.
                              }
                              @if (allowUpload && attachmentAlreadySupplied) {
                                <fa-icon [icon]="faFileXmark" class="me-1"></fa-icon>
                                The previously supplied attachment will be deleted upon submission.
                              }
                              @if (f.attachment.invalid && f.attachment.errors?.invalidFile) {
                                <fa-icon [icon]="faFileXmark" class="me-1"></fa-icon>
                                The supplied attachment is an invalid file type.
                              }
                            </div>
                            <div class="col-12 col-md-5 text-end">
                              <button type="button" class="btn btn-sm btn-link p-0" (click)="toggleExistingAttachment()">
                                @if (!allowUpload) {
                                  <fa-icon [icon]="faTimes" class="me-1"></fa-icon>
                                  Delete
                                }
                                @if (allowUpload) {
                                  Cancel
                                }
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if ((!attachmentAlreadySupplied && !f.attachment.value) || allowUpload) {
                    <div class="row mb-4">
                      <div class="col-12">
                        <input type="file" class="form-control" name="attachment" id="attachment"
                          [class.is-invalid]="f.attachment.touched && f.attachment.invalid" (change)="onFileChange($event)">
                        @if (f.attachment.errors?.required) {
                          <div class="invalid-feedback">
                            Required
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="form-floating col-12">
                      <textarea class="form-control" id="comments"
                        placeholder="What has impacted (negative or positive) your sales this month?"
                      formControlName="comments" [class.is-invalid]="f.comments.touched && f.comments.invalid" maxlength="300" appExpandingTextbox></textarea>
                      <label for="comments">What has impacted (negative or positive) your sales this month?</label>
                      @if (f.comments.errors?.maxLength) {
                        <div class="invalid-feedback">
                          Limited to 300 characters
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-grid">
                      @if (!isLocalhost) {
                        <div id="captcha-container"></div>
                      }
                      @if (captchaErrorMessage) {
                        <div class="alert alert-warning small mb-3">
                          {{ captchaErrorMessage }}
                        </div>
                      }
                      <button type="submit" class="btn btn-primary btn-lg" [disabled]="isUploading || isSubmitting || isCaptchaLoading || !form.dirty">
                        @if (isCaptchaLoading) {
                          <fa-icon [icon]="faSpinnerThird" animation="spin" class="me-1"></fa-icon>
                          Loading captcha...
                        }
                        @if (!isCaptchaLoading && isSubmitting) {
                          <fa-icon [icon]="faSpinnerThird" animation="spin" class="me-1"></fa-icon>
                          Submitting...
                        }
                        @if (!isCaptchaLoading && !isSubmitting) {
                          Submit
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            }
            @if (hasSubmitted && wasSubmitSuccessful) {
              <strong>
                Thanks! Your submission was successful.
              </strong>
              <br>
                <br>
                  @if (daysLeftToEdit) {
                    <p>
                      You can follow the link in the email again, anytime within the next {{ daysLeftToEdit }} {{ daysLeftToEdit
                      === 1 ? 'day' : 'days' }}, to amend your submission.
                    </p>
                    <button class="btn btn-primary" (click)="load()">
                      <fa-icon [icon]="faEdit" class="me-1"></fa-icon>
                      Amend Submission
                    </button>
                  }
                }
              }
            </div>
          </div>
        </div>
